export default "__VITE_ASSET__Bx7hYM0A__"